import _slicedToArray from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { createContext, useEffect, useState } from 'react';
import { useFetcher } from 'rest-hooks';
import { PublicSettingsResource } from '../api';
export var LoadSettingContext = createContext(undefined);
export var LoadSettingContextProvider = function LoadSettingContextProvider(_ref) {
  var settings = _ref.settings,
      children = _ref.children;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var fetchData = useFetcher(PublicSettingsResource.list());
  useEffect(function () {
    fetchData({}).then(function (data) {
      if (data.length > 0) {
        setData(data.filter(function (e) {
          return settings.includes(e.key);
        }));
      }
    });
  }, [setData, fetchData, settings]);
  return React.createElement(LoadSettingContext.Provider, {
    value: data
  }, children);
};